import { Typography } from '@mui/material'
import React, { useContext } from 'react'
import Link from '@mui/material/Link'
import { Root, classes } from './FriendsFavoriteList.styles'
import CloseIcon from '@mui/icons-material/Close'
import { useMutation } from '@apollo/client'
import { DELETE_PROSPECT_RECEIVED_FAVORITES } from '../../../graphql/favorites'
import { deleteSharedFavoritesLink, setSnackBar } from '../../../store/reducers'
import { StoreContext } from '../../../store'

export default function FriendsFavoriteList({
  receivedFavorites,
  client,
  prospectId,
}) {
  const { dispatch } = useContext(StoreContext)
  const [deleteSharedFavorites] = useMutation(
    DELETE_PROSPECT_RECEIVED_FAVORITES
  )

  if (!receivedFavorites?.length) {
    return null
  }

  function handleRemoveSharedFavorites(clientId, senderProspectId) {
    deleteSharedFavorites({
      variables: {
        clientId,
        senderProspectId,
        receiverProspectId: prospectId,
      },
    })
      .then(() =>
        dispatch(
          deleteSharedFavoritesLink({
            clientId,
            senderProspectId,
          })
        )
      )
      .catch(() =>
        dispatch(
          setSnackBar({
            open: true,
            message: 'Failed to remove friends shared favorites.',
            type: 'error',
          })
        )
      )
  }

  return (
    <Root>
      <Typography className={classes.title} variant={'body1'}>
        View Favorites From Friends
      </Typography>
      <div className={classes.favoritesList}>
        {receivedFavorites.map((fav) => {
          if (client.id === fav.clientId) {
            return (
              <div
                key={`${fav.clientId}${fav.sentByProspectId}`}
                className={classes.item}
              >
                <Link
                  href={`${process.env.REACT_APP_TRUSS}/client/${fav.clientAltName}/compareFavorites?email=${fav.sentByProspectEmail}&name=${fav.sentByProspectName}`}
                  onClick={(evt) => evt.preventDefault}
                >
                  {`${fav.sentByProspectName}'s Favorites`}
                </Link>
                <CloseIcon
                  color="secondary"
                  className={classes.removeIcon}
                  onClick={() =>
                    handleRemoveSharedFavorites(
                      fav.clientId,
                      fav.sentByProspectId
                    )
                  }
                />
              </div>
            )
          }

          return null
        })}
      </div>
    </Root>
  )
}
